module.exports = __webpack_public_path__ + "img/ic_email.2e25c297.svg";